import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CreateSendProductReportComponent } from '../../sections/createSendProductReport/create-send-product-report/create-send-product-report-component';
import { MeddraComponent } from '../../sections/meddra/meddra/meddra.component';
import { MedicinalProductComponent } from '../../sections/medicinalProduct/medicinal-product/medicinal-product.component';
import { WebtraderComponent } from '../../sections/webtrader/webtrader/webtrader.component';
import { AuthService } from '../../shared/service/auth-service/auth-service.service';
import { SectionService } from '../../shared/service/section-service/section-service';
import { Art57Section } from '../../shared/ui/Art57Section/Art57Section';
import { SectionName } from '../../shared/ui/SectionName';
import { PostComponent } from '../../sections/post/post.component';
import { BulkExportComponent } from '../../sections/bulkExport/bulk-export/bulk-export.component';
import { BulkUpdateComponent } from '../../sections/bulkUpdate/bulk-update/bulk-update.component';

@Component({
  selector: 'app-main-section',
  templateUrl: './section-container.component.html',
  styleUrl: './section-container.component.scss'
})
export class SectionContainerComponent implements OnInit {
  @ViewChild('container', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;
  private subscription!: Subscription;
  private currentSection: any;

  constructor(
    private componentLoaderService: SectionService,
    private authService: AuthService,
    private art57Sections: Art57Section
  ) {}
 
  ngOnInit() {

    this.initializeApplication();

    this.subscription = this.componentLoaderService.componentLoad$.subscribe(
      componentName => {
      this.loadSection(componentName);
    });

    this.loadSection(this.authService.selectedSection); 
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  loadSection(sectionName: string) {

    let componentType: any;
    this.container.clear();

    switch (sectionName) {
      case SectionName.webtrader:
        componentType = WebtraderComponent;
        break;
      case SectionName.createandsendproductreports:
        componentType = CreateSendProductReportComponent;
        break;
      case SectionName.medicinalproducts:
        componentType = MedicinalProductComponent;
        break;
      case SectionName.meddra:
        componentType = MeddraComponent;
        break;
      case SectionName.post:
        componentType = PostComponent;
        break;
      case SectionName.bulkexport:
        componentType = BulkExportComponent;
        break;
      case SectionName.bulkupdate:
        componentType = BulkUpdateComponent;
        break;
    }

    if (componentType) {
      this.currentSection = sectionName;
      this.container.createComponent(componentType);
    }
  }

  initializeApplication(){
    // Initialization with a section Reset
    this.art57Sections.initSections();
  }
}

